import React, { useMemo } from 'react';
import SidebarMenu from './SidebarMenu';
import useMensajesNoLeidos from '../../../hooks/useMensajesNoLeidos';

const BASE_PARTICULAR_MENU_ITEMS = [
  { id: 'resumen', label: 'Resumen', icon: 'fas fa-chart-line' },
  { id: 'mensajes', label: 'Mensajes', icon: 'fas fa-envelope', path: '/mensajes', state: { scope: 'particulares' } },
  { id: 'calendario', label: 'Calendario', icon: 'fas fa-calendar-alt', requiresCalendarAccess: true },
  { id: 'etiquetas', label: 'Etiquetas', icon: 'fas fa-tags' },
  { id: 'cursos', label: 'Cursos', icon: 'fas fa-layer-group' },
  { id: 'profesoresAsociados', label: 'Profesores', icon: 'fas fa-user-tie', requiresProfesoresAccess: true },
  { id: 'alumnos', label: 'Alumnos', icon: 'fas fa-user-graduate' },
  { id: 'invitaciones', label: 'Invitaciones', icon: 'fas fa-ticket-alt', requiresInvitacionesAccess: true },
  { id: 'cuentaCorriente', label: 'Cta. Cte.', icon: 'fas fa-file-invoice-dollar', requiresCuentaCorrienteAccess: true },
  { id: 'aulas', label: 'Aulas', icon: 'fas fa-door-open' },
  { id: 'asistentes', label: 'Asistentes IA', icon: 'fas fa-robot', requiresChatGPTAccess: true }
];

const buildParticularDashboardMenuItems = ({
  externalNavigation = false
} = {}) => (
  BASE_PARTICULAR_MENU_ITEMS
    .map((item) => {
      if (!externalNavigation || item.path) return item;
      return {
        ...item,
        path: '/particular',
        state: { activeMenu: item.id }
      };
    })
);

const ParticularDashboardMenu = ({
  activeId,
  onNavigate,
  className = '',
  externalNavigation = false,
  messageScope = 'particular'
}) => {
  const { count: mensajesNoLeidos } = useMensajesNoLeidos(true, { scope: messageScope });
  const items = useMemo(() => buildParticularDashboardMenuItems({
    externalNavigation
  }).map((item) => (
    item.id === 'mensajes' ? { ...item, badge: mensajesNoLeidos } : item
  )), [
    externalNavigation,
    mensajesNoLeidos
  ]);

  return (
    <SidebarMenu
      items={items}
      activeId={activeId}
      onNavigate={onNavigate}
      className={className}
    />
  );
};

export { buildParticularDashboardMenuItems, BASE_PARTICULAR_MENU_ITEMS };
export default ParticularDashboardMenu;
